import { useLang } from '@/lib/LanguageContext';

export default function StepDescriptionBudget({ data, setData }) {
  const { t } = useLang();
  return (
    <div className="space-y-5">
      <div>
        <label className="text-xs font-inter font-medium tracking-[0.15em] uppercase text-muted-foreground mb-2 block">{t('Project Description')}</label>
        <textarea
          rows={4}
          required
          value={data.description}
          onChange={(e) => setData({ ...data, description: e.target.value })}
          className="w-full px-4 py-3 rounded-lg bg-secondary/50 border border-border/50 text-foreground font-inter text-sm placeholder:text-muted-foreground/50 focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/20 transition-all resize-none"
          placeholder={t('Tell us about your project, goals, and any specific requirements...')} />
      </div>
      <div>
        <label className="text-xs font-inter font-medium tracking-[0.15em] uppercase text-muted-foreground mb-2 block">{t('Budget')}</label>
        <input
          type="text"
          value={data.budget}
          onChange={(e) => setData({ ...data, budget: e.target.value })}
          className="w-full px-4 py-3 rounded-lg bg-secondary/50 border border-border/50 text-foreground font-inter text-sm placeholder:text-muted-foreground/50 focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/20 transition-all"
          placeholder={t('e.g. $2,000 - $5,000')} />
      </div>
    </div>
  );
}